import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { toWords } from 'number-to-words';
import { wtFormatMoneyRoundData, wtFormatRoundedValue, wtRoundValue } from 'src/helpers/commons/utils';

// Capitalizes the first letter of each word, taking care of hyphenated words
const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const capitalizeEachWord = (str) => {
    return str.split(/(\s|-|,)/).map(word => capitalizeFirstLetter(word)).join('');
};

const formatChequeDate = (date) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(date).toLocaleDateString('en-GB', options).replace(/ /g, ' - ');
};

const getCoordinate = (value, fallback) => value ?? fallback;

const renderChequePage = (doc, data) => {
    const chequeDate = data.chequeDate ? formatChequeDate(data.chequeDate) : "N/A";
    const beneficiaryName = data.beneficiaryName || "N/A";
    const amount = data.amount || 0;

    let amountInWords = `*** ${toWords(amount)} Only ***`;
    amountInWords = capitalizeEachWord(amountInWords);

    doc.setFontSize(9);
    doc.text(
        beneficiaryName,
        getCoordinate(data.beneficiary_name_x, 113),
        getCoordinate(data.beneficiary_name_y, 15),
        { angle: data.angle ?? 270 }
    );

    doc.setFontSize(10);
    doc.text(
        chequeDate,
        getCoordinate(data.cheque_date_x, 120),
        getCoordinate(data.cheque_date_y, 128),
        { angle: data.angle ?? 270 }
    );

    doc.setFontSize(9);

    const maxLineWidth = 100;
    const amountInWordsLines = doc.splitTextToSize(amountInWords, maxLineWidth);

    doc.text(
        amountInWordsLines,
        getCoordinate(data.amount_in_word_x, 105),
        getCoordinate(data.amount_in_word_y, 20),
        { angle: data.angle ?? 270 }
    );
    doc.text(
        `= ${wtFormatMoneyRoundData(amount,"")}/-`,
        getCoordinate(data.amount_x, 105),
        getCoordinate(data.amount_y, 140),
        { angle: data.angle ?? 270 }
    );
}

const ChequePrintPDF = (data) => {
    const pages = Array.isArray(data) ? data : [data];
    const doc = new jsPDF();

    pages.forEach((page, index) => {
        if (index > 0) {
            doc.addPage();
        }

        renderChequePage(doc, page);
    });

    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, '_blank');
};

export default ChequePrintPDF;
